/* Caveau - sconto di benvenuto nel carrello (snippets/caveau-cart-welcome.liquid, drawer e pagina carrello).
   "Applica lo sconto": un clic mette il codice sul carrello con la Cart AJAX API (/cart/update.js, parametro discount)
   senza lasciare il carrello; il carrello viene ridisegnato (prezzi, Subtotale, barra dei campioni) e il codice passa
   da solo al pagamento. "Rimuovi" lo toglie. Il parametro discount sostituisce tutti i codici del carrello: per non
   perdere un altro codice già presente si legge prima /cart.js e si rimandano anche gli altri.
   Se il codice non vale per i prodotti nel carrello, viene tolto subito e compare un avviso.
   Senza JavaScript il tasto resta un link /discount/CODICE?redirect=/cart. */
(() => {
  'use strict';
  if (window.__caveauWelcome) return;
  window.__caveauWelcome = true;

  const routes = window.routes || {};
  const CART_URL = routes.cart_url || '/cart';
  const UPDATE_URL = (routes.cart_update_url || '/cart/update') + '.js';
  const DRAWER = '[data-line-items-drawer-container]';
  const PAGE = '[data-line-items-container]';

  // Stessa logica di assets/caveau-conv.js: nella pagina carrello la sezione ha un id generato dal template.
  const cartSectionId = () => {
    const page = document.querySelector(PAGE);
    const wrap = page ? page.closest('.shopify-section') : null;
    return wrap && wrap.id ? wrap.id.replace('shopify-section-', '') : 'main-cart';
  };

  // Ridisegna drawer, pagina carrello e contatori con l'HTML della sezione carrello (come caveau-conv.js).
  const renderCart = (markup) => {
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const template = doc.querySelector('template');
    const source = template ? template.content : doc;

    ['[data-cart-bubble]', '[data-cart-bubble-text]'].forEach((selector) => {
      const from = source.querySelector(selector);
      if (!from) return;
      document.querySelectorAll(selector).forEach((element) => {
        element.innerHTML = from.innerHTML;
      });
    });

    const drawer = document.querySelector(DRAWER);
    const drawerFrom = source.querySelector(DRAWER);
    if (drawer && drawerFrom) {
      const scroller = drawer.querySelector('.modal-component_content');
      const top = scroller ? scroller.scrollTop : 0;
      drawer.innerHTML = drawerFrom.innerHTML;
      const next = drawer.querySelector('.modal-component_content');
      if (next) next.scrollTop = top;
    }

    const page = document.querySelector(PAGE);
    const pageFrom = doc.querySelector(PAGE);
    if (page && pageFrom) page.innerHTML = pageFrom.innerHTML;
    return !!((drawer && drawerFrom) || (page && pageFrom));
  };

  const same = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

  const codesOf = (cart) => (cart && Array.isArray(cart.discount_codes)
    ? cart.discount_codes.map((entry) => entry && entry.code).filter(Boolean)
    : []);

  // Il codice vale per questo carrello? Prima discount_codes (code + applicable), poi gli sconti sulle righe.
  const isApplied = (cart, code) => {
    if (!cart) return false;
    if (Array.isArray(cart.discount_codes)) {
      const hit = cart.discount_codes.find((entry) => entry && same(entry.code, code));
      if (hit && hit.applicable === true) return true;
      if (hit && hit.applicable === false) return false;
    }
    const items = Array.isArray(cart.items) ? cart.items : [];
    const onItems = items.some((item) => (item.discounts || []).some((d) => same(d.title, code)));
    const onCart = (cart.cart_level_discount_applications || []).some((d) => same(d.title, code));
    return onItems || onCart;
  };

  const getCart = () => fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error('cart');
      return response.json();
    });

  const update = (discount, section) => fetch(UPDATE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount, sections: section, sections_url: window.location.pathname })
  }).then((response) => {
    if (!response.ok) throw new Error('update');
    return response.json();
  });

  const showMessage = (text) => {
    document.querySelectorAll('[data-cv-welcome-msg]').forEach((element) => {
      element.textContent = text;
      element.hidden = !text;
    });
  };

  let busy = false;

  document.addEventListener('click', (event) => {
    const target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    const apply = target.closest('[data-cv-welcome-apply]');
    const remove = apply ? null : target.closest('[data-cv-welcome-remove]');
    if (!apply && !remove) return;
    const box = (apply || remove).closest('[data-cv-welcome]');
    if (!box || !window.fetch || !window.DOMParser) return; // senza fetch il link funziona da solo
    event.preventDefault();
    if (busy) return;

    const code = box.dataset.code || '';
    const textNa = box.dataset.textNa || '';
    const textError = box.dataset.textError || '';
    const section = cartSectionId();
    const trigger = apply || remove;
    busy = true;
    trigger.classList.add('is-busy');
    trigger.setAttribute('aria-disabled', 'true');
    showMessage('');

    getCart()
      .then((cart) => {
        const others = codesOf(cart).filter((entry) => !same(entry, code));
        const list = apply ? others.concat([code]) : others;
        return update(list.join(','), section).then((result) => ({ result, others }));
      })
      .then(({ result, others }) => {
        if (apply && !isApplied(result, code)) {
          // Non vale per i prodotti nel carrello: lo togliamo subito, così non arriva al pagamento.
          return update(others.join(','), section).then((cleaned) => {
            if (cleaned.sections && cleaned.sections[section]) renderCart(cleaned.sections[section]);
            showMessage(textNa);
          });
        }
        const drawn = result.sections && result.sections[section] ? renderCart(result.sections[section]) : false;
        if (!drawn) window.location.reload();
        return null;
      })
      .catch(() => {
        showMessage(textError);
      })
      .finally(() => {
        busy = false;
        if (trigger.isConnected) {
          trigger.classList.remove('is-busy');
          trigger.removeAttribute('aria-disabled');
        }
      });
  });
})();
